<template>
  <div style="height: 100%">
    <div class="sa-flexbox" style="padding-bottom: 20px">
      <div class="sa-flexbox-body">
        <div class="d-flex flex-column">
          <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
            <b-col lg="3">
              <p>Records Totali: {{ rows }}</p>
            </b-col>
            <b-col lg="9">
              <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right"
                size="sm"></b-pagination>
            </b-col>
          </b-row>
        </div>
        <div class="b-table-sticky-header" style="margin-bottom: 1px;" v-show="initComponent">
          <transition name="animation" mode="out-in">
            <div v-if="items.length > 0" key="cards" style="padding:2px">
              <div class="sa-ft-card-list" style="">
                <div v-for="(item, index) in items" :key="item.primaryKey || index" class="sa-ft-modern-card"
                  :style="{ '--hover-color': getClass('hover', item.statoAttuale) }"
                  :class="getClass('card', item.statoAttuale)">
                  <b-row align-v="center" class="m-0 py-3">
                    <b-col cols="12" md="3" class="mb-2 mb-md-0">
                      <div class="sa-ft-label">
                        Nominativo
                      </div>
                      <div class="sa-ft-value">
                        <span style="display: block; font-weight: bold;">
                          {{ getNominativoAssistito(item, "nome-cognome") }}
                        </span>
                      </div>
                      <div class="sa-ft-value ml-1">
                        {{ getNominativoAssistito(item, "identificativo") }}
                      </div>
                    </b-col>
                    <b-col cols="12" md="2" class="mb-2 mb-md-0">
                      <div class="sa-ft-label"> GRUPPO
                      </div>
                      <span class="sa-ft-badge " :class="getClass('gruppo', item.statoAttuale)">
                        {{ item.gruppo }}
                      </span>
                    </b-col>
                    <b-col cols="12" md="2" class="mb-2 mb-md-0">
                      <div class="sa-ft-label">NOTE</div>
                      <div class=" text-break" style="max-height: 60px; overflow-y: auto;">
                        <div class="sa-ft-value"> {{ item.noteCaratteristichePaziente }}</div>
                      </div>
                    </b-col>
                    <b-col cols="6" md="2" class="mb-2 mb-md-0 ">
                      <div class="sa-ft-label">STATO</div>
                      <div class="mt-1">
                        <span class="sa-ft-badge" :class="getClass('stato', item.statoAttuale)">
                          {{ item.statoAttuale }}
                        </span>
                      </div>
                    </b-col>

                    <b-col cols="6" md="2" class="mb-2 mb-md-0 align-content-center">
                      <div class="sa-ft-label">
                        Data Accettazione
                      </div>
                      <div class="sa-ft-value">
                        {{ formatDateTime(item.accettazione.dataAccettazione) }}
                      </div>

                    </b-col>
                    <b-col cols="12" md="1" class="text-right mt-3 mt-md-0">
                      <div class="d-flex justify-content-md-end ft-gap-8-px">
                        <template>
                          <b-button v-b-tooltip.hover size="sm"
                            variant="outline-info outline-secondary-noborder pull-right" title="Scheda Paziente"
                            @click="onClickSchedaPaziente(item)"
                            class="mr-1 no-text rounded-circle sa-ft-floating-btn primary">
                            <b-icon icon="eye" variant="outline-info"></b-icon>
                          </b-button>
                        </template>
                      </div>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </div>
            <NoDataComponent v-else ref="cmpNoDataComponent" title="Non sono presenti accettazioni" nome="no-data"
              subtitle="" icon="fas fa-users" />
          </transition>
        </div>
      </div>
      <div class="d-flex flex-column">
        <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
          <b-col lg="3">
            <p>Records Totali: {{ rows }}</p>
          </b-col>
          <b-col lg="9">
            <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right"
              size="sm"></b-pagination>
          </b-col>
        </b-row>
      </div>
      <b-modal ref="mdlScelta">
        <template></template>
      </b-modal>

      <pdf-print-view-embedded ref="pdfPrintViewEmbedded" :pdf="signedPdfViewer"></pdf-print-view-embedded>
    </div>
  </div>
</template>

<script>
import axios from "axios";
// import PrintComponent from "../../../utility/components/PdfPrintViewEmbedded.vue";
import UtilityMixin from "../../../utility/UtilityMixin";
import PdfPrintViewEmbedded from "../../../utility/components/PdfPrintViewEmbedded.vue";
//import PrintComponent from "../../../utility/components/PrintComponent.vue";
import NoDataComponent from "../../../../template/components/utility/NoDataComponent.vue";

import moment from "moment";
import toast from "../../../../template/layout/utility/sa-toast";
export default {
  //PrintComponent
  mixins: [UtilityMixin],
  components: { PdfPrintViewEmbedded, NoDataComponent },
  data() {
    return {
      initComponent: false,
      pathResource: "/accettazionessn",
      pathResourceRicette: "/accettazionericette",
      items: [],
      rows: 0,
      filtro: {
        codiceFiscaleAssistito: null,
        idPresidio: null,
      },
      page: 1,
      perPage: 20,
      signedPdfViewer: null,
      listKey: 0,
      previewSelected: null,
      currentPage: 1,
      rowSelectedAccettazione: {},
      listaRicetteDetails: {},

    };
  },

  mounted() {
    let me = this;
    me.init();

  },
  methods: {
    init() {
      let me = this;
      me.loadData();
    },
    getOra(date) {
      return moment(date).format("HH:mm");
    },
    getFormatDate(date) {
      return moment(date).format("DD/mm/yyyy");
    },
    onClickSchedaPaziente(item) {
      this.$router.push("/rsapaziente/view/" + item.id)
    },

    loadData() {
      let me = this;
      me.$emit("beforeLoadData");
      me.items = [];
      let filtroStr = sessionStorage.getItem("filtroPageAccettazioneSsn");
      let filtroJson = JSON.parse(filtroStr);
      me.filtro = filtroJson;
      console.log(me.filtro);

      this.$emit("updateFilter", me.filtro)
      this.initComponent = true;
      if (me.filtro != null) {
        me.filtro.page = me.currentPage;
        me.filtro.forPage = me.perPage;
        if (me.filtro.idPresidio == null) {
          me.$emit("afterLoadData");
          toast.warning("Selezionare Presidio !")
          return;
        }
      }

      UtilityMixin.methods.loadDataResources(me.pathResource, me.filtro, me.loadDataAccettazioneSsnSuccess, me.loadDataAccettazioneSsnError);
    },

    loadDataAccettazioneSsnSuccess(response) {
      let me = this;
      me.items = response.data.data.list;
      me.rows = response.data.data.recordsNumber;
      me.listKey++;
      me.$emit("afterLoadData");

    },
    loadDataAccettazioneSsnError(response) {
      let me = this;
      me.$emit("afterLoadData", response);
      console.log(response);

      me.$bvToast.toast(response.response.data.messaggio, {
        title: "Errore",
        variant: "danger",
        solid: true,
      });

    },
    getColorBackGround(prestazione) {
      let color = "#b6b5b5";
      color = prestazione.appuntamenti.length == prestazione.quantita ? "#00a3ff" : "#ffc107";
      return color;
    },
    linkPrintData(item) {
      let returnValue = "/printer/" + item.id;
      return returnValue;
    },
    onClickOpenDetailAccettazione(accettazione) {
      this.$router.push("accettazionessn/" + accettazione.id);
    },
    onClickDettaglio(row) {
      if (this.listaRicetteDetails[row.item.id]) {
        row.toggleDetails();
      } else {
        this.loadRicetteByAccettazione(row);
      }
    },
    loadRicetteByAccettazione(row) {
      let link = process.env.VUE_APP_PATH_API + this.pathResourceRicette;
      axios
        .get(link, { params: { idAccettazione: row.item.id } })
        .then((response) => {
          this.listaRicetteDetails[row.item.id] = response.data.data.list;
          row.toggleDetails();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    onClickAnteprimaStampa(item) {
      let me = this;
      let prestazioni = null;
      let identificativo = item.accettazione.accettazioneAnagrafica.identificativo;
      if (item.ricette.length >= 1) {
        prestazioni = item.ricette[0].prestazioni;
      } else {
        //TODO
      }
      let print = {
        reportName: "RegistroPresenze",
        data: {
          identificativo: identificativo,
          prestazioni: prestazioni,
        },
      };
      me.onPrintPreview(print);
    },
    getNominativoAssistito(item, sezione) {
      let anagrafica = item.accettazioneAnagrafica;
      switch (sezione) {
        case "nome-cognome":
          return anagrafica.cognome + " " + anagrafica.nome
        case "identificativo":
          return anagrafica.identificativo
        default:
          break;
      }

    },
    getClass(sezione, valore) {
      switch (sezione) {
        case 'stato':
          if (valore == 'ACCETTATO') {
            return 'sa-ft-modern-card-default'
          } else if (valore == 'IN CORSO') {
            return 'sa-ft-modern-card-blue'
          } else if (valore == 'IN ATTESA') {
            return 'sa-ft-modern-card-green'
          }
          else {
            return 'sa-ft-modern-card-red'
          }
        case 'gruppo':
          if (valore == 'ACCETTATO') {
            return 'sa-ft-modern-card-default'
          } else if (valore == 'IN CORSO') {
            return 'sa-ft-modern-card-blue'
          } else if (valore == 'IN ATTESA') {
            return 'sa-ft-modern-card-green'
          }
          else {
            return 'sa-ft-modern-card-red'
          }
        case 'card':
          if (valore == 'ACCETTATO') {
            return 'sa-ft-modern-card-default'
          } else if (valore == 'IN CORSO') {
            return 'sa-ft-modern-card-blue'
          } else if (valore == 'IN ATTESA') {
            return 'sa-ft-modern-card-green'
          }
          else {
            return 'sa-ft-modern-card-red'
          }
        default:
          break;
      }
    },
    onClickAnnulla() {
      let me = this;
      me.$refs.mdlPreviewStampa.hide();
    },
    onPrintPreview(item) {
      let me = this;
      let link = process.env.VUE_APP_PATH_API + "/print/createreport";
      me.showModalLoading = true;
      axios
        .post(link, item)
        .then((response) => {
          me.signedPdfViewer = "data:application/pdf;base64," + response.data.base64;

          me.$refs.pdfPrintViewEmbedded.show();
        })
        .catch((error) => {
          // me.$refs.mdlGenerazioneReportInCorso.hide();
          me.showModalLoading = false;
          let messaggio = error.response.data.messaggio ? error.response.data.messaggio : "Errore non gestito, Codice: " + error.response.status;
          this.$bvModal
            .msgBoxOk(messaggio, {
              title: this.$i18n.t("ERROR!"),
              size: "sm",
              okVariant: "outline-danger",
              headerClass: "sa-msg-header-danger",
              footerClass: "p-2 border-top-0",
              centered: true,
            })
            .then((value) => {
              this.boxTwo = value;
            })
            .catch((err) => {
              err;
            });
        });
    },
  },
  watch: {
    currentPage() {
      let me = this;
      me.loadData();
    },
  },
};
</script>

<style scoped>
.animation-enter-active,
.animation-leave-active {
  transition: opacity 0.8s ease, transform 0.8s ease;
}

.animation-enter-from {
  opacity: 0;
  transform: translateY(20px);
}

.animation-enter-to {
  opacity: 1;
  transform: translateY(0px);
}

.animation-leave-from {
  opacity: 1;
  transform: translateY(0px);
}

.animation-leave-to {
  opacity: 0;
  transform: translateY(20px);
}
</style>
